function SvgComponent(props) {
  return (
    <svg
      width="160"
      height="160"
      viewBox="0 0 160 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Property 1=Variant2">
        <g clip-path="url(#clip0_2597_869)">
          <g id="Group 1">
            <path
              id="Vector"
              d="M91.0952 117.288H68.9271V139.46H91.0952V117.288Z"
              fill="#121014"
            />
            <path
              id="Vector_2"
              d="M103.586 130.231H56.4367C49.6129 130.231 44.0811 135.764 44.0811 142.589V181.712C44.0811 188.537 49.6129 194.069 56.4367 194.069H103.586C110.41 194.069 115.942 188.537 115.942 181.712V142.589C115.942 135.764 110.41 130.231 103.586 130.231Z"
              fill="#EE6C4C"
            />
            <path
              id="Vector_3"
              d="M81.7104 28.8917H78.3345V58.3797H81.7104V28.8917Z"
              fill="#D65238"
            />
            <path
              id="Vector_4"
              d="M31.2753 73.3936H22.7007C21.2091 73.3936 20 74.6029 20 76.0947V96.3087C20 97.8005 21.2091 99.0099 22.7007 99.0099H31.2753C32.7669 99.0099 33.976 97.8005 33.976 96.3087V76.0947C33.976 74.6029 32.7669 73.3936 31.2753 73.3936Z"
              fill="#D65238"
            />
            <path
              id="Vector_5"
              d="M137.299 73.3936H128.725C127.233 73.3936 126.024 74.6029 126.024 76.0947V96.3087C126.024 97.8005 127.233 99.0099 128.725 99.0099H137.299C138.791 99.0099 140 97.8005 140 96.3087V76.0947C140 74.6029 138.791 73.3936 137.299 73.3936Z"
              fill="#D65238"
            />
            <path
              id="Vector_6"
              d="M113.938 54.3507H46.084C34.8974 54.3507 25.8289 63.4209 25.8289 74.6096V97.7949C25.8289 108.984 34.8974 118.054 46.084 118.054H113.938C125.125 118.054 134.194 108.984 134.194 97.7949V74.6096C134.194 63.4209 125.125 54.3507 113.938 54.3507Z"
              fill="#EE6C4C"
            />
            <path
              id="Vector_7"
              d="M96.6991 62.4087H63.3232C50.1852 62.4087 39.5347 73.0612 39.5347 86.2017C39.5347 99.3422 50.1852 109.995 63.3232 109.995H96.6991C109.837 109.995 120.488 99.3422 120.488 86.2017C120.488 73.0612 109.837 62.4087 96.6991 62.4087Z"
              fill="#121014"
            />
            <ellipse id="ER" cx="97.5" cy="84" rx="7.5" ry="1" fill="#FEFEFC" />
            <path
              id="Vector_8"
              d="M80.0227 93.7653C75.8366 93.7653 72.4158 90.3663 72.4158 86.157C72.5038 85.4817 72.7083 85.4817 73.0909 85.4817C73.4735 85.4817 73.7661 85.7743 73.7661 86.157C73.7661 89.601 76.5793 92.4148 80.0227 92.4148C83.466 92.4148 86.2792 89.601 86.2792 86.157C86.4286 85.4817 86.5718 85.4817 86.9544 85.4817C87.337 85.4817 87.6296 85.7743 87.6296 86.157C87.6296 90.3438 84.2312 93.7653 80.0227 93.7653Z"
              fill="#FEFEFC"
            />
            <path
              id="Vector_9"
              d="M80.0001 38.0079C84.9719 38.0079 89.0023 33.9767 89.0023 29.004C89.0023 24.0312 84.9719 20 80.0001 20C75.0283 20 70.9978 24.0312 70.9978 29.004C70.9978 33.9767 75.0283 38.0079 80.0001 38.0079Z"
              fill="#EE6C4C"
            />
            <ellipse id="EL" cx="62.5" cy="84" rx="7.5" ry="1" fill="#FEFEFC" />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2597_869">
          <rect width="160" height="160" rx="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgComponent;
